import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LicenseTypeSummary } from 'mbs-ui-shared@models/License';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ResellerLicenseTypesService {
  private httpClient = inject(HttpClient);

  private readonly baseHref = '/api/license-types';

  public getTypes(): Observable<LicenseTypeSummary[]> {
    return this.httpClient.get<LicenseTypeSummary[]>(`${this.baseHref}/all`, { withCredentials: true });
  }
}
